// extracted by mini-css-extract-plugin
export default {"overlay":"Overlay_overlay__EC2Wf"};